import { render, staticRenderFns } from "./PostingDestinationsPanel.vue?vue&type=template&id=24395f87&"
import script from "./PostingDestinationsPanel.vue?vue&type=script&lang=js&"
export * from "./PostingDestinationsPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports